import React from 'react';
import './Componenst.css';
import ContactModel from '../models/ContactModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createContact, showError } from '../ViewCreator';

function Contact({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new ContactModel();


    const clearSubmit = () => {
        document.getElementById('contactValue').value     = '';
    document.getElementById('contactKey').value     = '';
    personModel.contactValue = ''
    personModel.contactKey = ''
    if (searchModel != undefined ) {
      searchModel.contact.contactValue = ''
      searchModel.contact.contactKey = ''
    }
    }

    const addSubmit = () => {
        if (personModel.contactKey == undefined || personModel.contactKey == '') {
            showError('Тип не може бути пустим')
            return;
        }

        if (personModel.contactValue == undefined || personModel.contactValue == '') {
            showError('Значення не може бути пустим')
            return;
        }

          isUniq()
    }

    const isUniq = () => {
        var path = ip + '/api/contact/search';
        personModel.searchModel = new SearchModel()
        var pp = new ContactModel();
        pp.contactKey = personModel.contactKey
        pp.contactValue = personModel.contactValue
        var bd = encryptAes(JSON.stringify(pp))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
    
              if (result.data.length > 0) {
                Swal.fire({
                    title: 'Запис уже існує',
                    //text: "Оновити інформацію?",
                    icon: 'warning',
                    html:
                    'Запис з такими даними вже існує, Ви можете ' +
                    '<a href="/contact?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'ОК',
                      denyButtonText: 'Оновити',
                      background: '#2B2B2B',
                      color: '#FFF'
                    }).then((result) => {
                    })
                  sendSearch()
              } else {
                Swal.fire({
                  title: 'Ви дійсно бажаєте створити новий запис',
                  //text: "Оновити інформацію?",
                  icon: 'question',
                  html:
                  '',
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: 'Створити',
                  denyButtonText: 'Оновити',
    
                  background: '#2B2B2B',
                  color: '#FFF'
                }).then((result) => {
                  addNewContact()
                  })
                
              }
            }
          })
      }

      const addNewContact = () => {
        var path = ip + '/api/contact/add';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
              
    
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
              if (isAdd) {
                addNew(result.data, 20004)
                clearSubmit()
              } else {
              window.open("/edit/contact?id="+result.data, "_self")
              }
            }
          })
      }

    const sendContactFullScreen = (id) => {
        window.open("/contact?id=" + id)
    }

    const sendContact = (id) => {
        var path = ip + '/api/contact/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                    
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createContact(addr))
    
                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/contact/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        z.className = "listItem"
                        z.innerHTML = "<p align=\"left\">"+pers.contactKey + "<br>" + pers.contactValue;
                        z.style.display = "block";
                        const cl = i => () => {
                            sendContact(i)
                        }
                        const dblcl = i => () => {
                            sendContactFullScreen(i)
                        }
                        //z.onclick = cl(pers.id)
                        z.ondblclick = dblcl(pers.id)
                        var per = new ContactModel()
                        per.id = pers.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                            
                              if(id=='contactKey'){
                        
                                personModel.contactKey = l[index]
                                
                              }
                              if(id=='contactValue'){
                                personModel.contactValue = l[index]
                              }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }


       
    
      const contactKeychange = () =>  {
        personModel.contactKey = document.getElementById('contactKey').value
        changedfield('contactKey');
      }
    
      const contactValuechange = () =>  {
        personModel.contactValue = document.getElementById('contactValue').value
        changedfield('contactValue');
      }

    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-contact" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-contact" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-contact" className="input-button-right" type="submit" value="Пошук" />

               
         
          <div id="contactValueDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="contactValue" className="input-text" tabIndex="2" name="login" type="text" onChange={contactValuechange}  placeholder="Значення" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="contactValueList" className="list" />
          </div>
          <div id="contactKeyDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="contactKey" className="input-text" tabIndex="1" name="login" type="text" onChange={contactKeychange}  placeholder="Тип" autoComplete="off"onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="contactKeyList" className="list" />
          </div>
            </form>
        </div>
    );
}

export default Contact;